// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { accountsApiKeysListResponseTransformer, annotationsCreateResponseTransformer, annotationsListResponseTransformer, annotationsPartialUpdateResponseTransformer, annotationsRetrieveResponseTransformer, annotationsUpdateResponseTransformer, chaptersCreateResponseTransformer, chaptersListResponseTransformer, chaptersPartialUpdateResponseTransformer, chaptersRetrieveResponseTransformer, chaptersUpdateResponseTransformer, checkoutsChannelsRetrieveResponseTransformer, checkoutsCreateResponseTransformer, checkoutsInvoiceRetrieveResponseTransformer, checkoutsSuccessRetrieveResponseTransformer, checkoutsThanksRetrieveResponseTransformer, dubsListResponseTransformer, dubsPartialUpdateResponseTransformer, dubsRetrieveResponseTransformer, dubsUpdateResponseTransformer, profilePartialUpdateResponseTransformer, profileRetrieveResponseTransformer, pulseAnnotationAnalyticsRetrieveResponseTransformer, pulseChapterAnalyticsRetrieveResponseTransformer, pulseListResponseTransformer, pulseRetrieveResponseTransformer, videosAnnotationsListResponseTransformer, videosChaptersListResponseTransformer, videosCreateResponseTransformer, videosListResponseTransformer, videosPartialUpdateResponseTransformer, videosRetrieveResponseTransformer, videosUpdateResponseTransformer } from './transformers.gen';
import type { AccountsApiKeysListData, AccountsApiKeysListErrors, AccountsApiKeysListResponses, AccountsGetTokenCreateData, AccountsGetTokenCreateErrors, AccountsGetTokenCreateResponses, AccountsRefreshTokenCreateData, AccountsRefreshTokenCreateErrors, AccountsRefreshTokenCreateResponses, AccountsReserveUsernameCreateData, AccountsReserveUsernameCreateErrors, AccountsReserveUsernameCreateResponses, AccountsResetPasswordConfirmCreateData, AccountsResetPasswordConfirmCreateErrors, AccountsResetPasswordConfirmCreateResponses, AccountsResetPasswordCreateData, AccountsResetPasswordCreateErrors, AccountsResetPasswordCreateResponses, AnnotationsCreateData, AnnotationsCreateErrors, AnnotationsCreateResponses, AnnotationsDestroyData, AnnotationsDestroyErrors, AnnotationsDestroyResponses, AnnotationsListData, AnnotationsListErrors, AnnotationsListResponses, AnnotationsPartialUpdateData, AnnotationsPartialUpdateErrors, AnnotationsPartialUpdateResponses, AnnotationsRetrieveData, AnnotationsRetrieveErrors, AnnotationsRetrieveResponses, AnnotationsUpdateData, AnnotationsUpdateErrors, AnnotationsUpdateResponses, AssetsCreateData, AssetsCreateErrors, AssetsCreateResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChaptersCreateData, ChaptersCreateErrors, ChaptersCreateResponses, ChaptersDestroyData, ChaptersDestroyErrors, ChaptersDestroyResponses, ChaptersListData, ChaptersListErrors, ChaptersListResponses, ChaptersPartialUpdateData, ChaptersPartialUpdateErrors, ChaptersPartialUpdateResponses, ChaptersRetrieveData, ChaptersRetrieveErrors, ChaptersRetrieveResponses, ChaptersUpdateData, ChaptersUpdateErrors, ChaptersUpdateResponses, CheckoutsCancelRetrieveData, CheckoutsCancelRetrieveErrors, CheckoutsCancelRetrieveResponses, CheckoutsChannelsRetrieveData, CheckoutsChannelsRetrieveErrors, CheckoutsChannelsRetrieveResponses, CheckoutsCreateData, CheckoutsCreateErrors, CheckoutsCreateResponses, CheckoutsInvoiceRetrieveData, CheckoutsInvoiceRetrieveErrors, CheckoutsInvoiceRetrieveResponses, CheckoutsSuccessRetrieveData, CheckoutsSuccessRetrieveErrors, CheckoutsSuccessRetrieveResponses, CheckoutsThanksRetrieveData, CheckoutsThanksRetrieveErrors, CheckoutsThanksRetrieveResponses, DubsCreateData, DubsCreateErrors, DubsCreateResponses, DubsDestroyData, DubsDestroyErrors, DubsDestroyResponses, DubsListData, DubsListErrors, DubsListResponses, DubsPartialUpdateData, DubsPartialUpdateErrors, DubsPartialUpdateResponses, DubsRetrieveData, DubsRetrieveErrors, DubsRetrieveResponses, DubsUpdateData, DubsUpdateErrors, DubsUpdateResponses, LinkParseLinkRetrieveData, LinkParseLinkRetrieveErrors, LinkParseLinkRetrieveResponses, OnboardCreateData, OnboardCreateErrors, OnboardCreateResponses, OnboardVerifyRetrieveData, OnboardVerifyRetrieveErrors, OnboardVerifyRetrieveResponses, ProductsAmazonSearchRetrieveData, ProductsAmazonSearchRetrieveErrors, ProductsAmazonSearchRetrieveResponses, ProfilePartialUpdateData, ProfilePartialUpdateErrors, ProfilePartialUpdateResponses, ProfileRetrieveData, ProfileRetrieveErrors, ProfileRetrieveResponses, PulseAnnotationAnalyticsRetrieveData, PulseAnnotationAnalyticsRetrieveErrors, PulseAnnotationAnalyticsRetrieveResponses, PulseAnnotationsRetrieveData, PulseAnnotationsRetrieveErrors, PulseAnnotationsRetrieveResponses, PulseChapterAnalyticsRetrieveData, PulseChapterAnalyticsRetrieveErrors, PulseChapterAnalyticsRetrieveResponses, PulseChaptersRetrieveData, PulseChaptersRetrieveErrors, PulseChaptersRetrieveResponses, PulseInsightsRetrieveData, PulseInsightsRetrieveErrors, PulseInsightsRetrieveResponses, PulseListData, PulseListErrors, PulseListResponses, PulseRetrieveData, PulseRetrieveErrors, PulseRetrieveResponses, PulseSummaryRetrieveData, PulseSummaryRetrieveErrors, PulseSummaryRetrieveResponses, PulseVideoAnalyticsRetrieveData, PulseVideoAnalyticsRetrieveErrors, PulseVideoAnalyticsRetrieveResponses, SchemaRetrieveData, SchemaRetrieveErrors, SchemaRetrieveResponses, VideosAnnotationsListData, VideosAnnotationsListErrors, VideosAnnotationsListResponses, VideosChaptersListData, VideosChaptersListErrors, VideosChaptersListResponses, VideosCreateData, VideosCreateErrors, VideosCreateResponses, VideosDestroyData, VideosDestroyErrors, VideosDestroyResponses, VideosDownloadrCreateData, VideosDownloadrCreateErrors, VideosDownloadrCreateResponses, VideosListData, VideosListErrors, VideosListResponses, VideosPartialUpdateData, VideosPartialUpdateErrors, VideosPartialUpdateResponses, VideosRetrieveData, VideosRetrieveErrors, VideosRetrieveResponses, VideosShareCreateData, VideosShareCreateErrors, VideosShareCreateResponses, VideosUpdateData, VideosUpdateErrors, VideosUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const accountsApiKeysList = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiKeysListData, ThrowOnError>) => (options?.client ?? client).get<AccountsApiKeysListResponses, AccountsApiKeysListErrors, ThrowOnError>({
    responseTransformer: accountsApiKeysListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/accounts/api-keys',
    ...options
});

/**
 * Change Password
 *
 * Change the authenticated user's password. Requires the current password and a new password with confirmation.
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>) => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/accounts/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes a set of user credentials and returns a sliding JSON web token to
 * prove the authentication of those credentials.
 */
export const accountsGetTokenCreate = <ThrowOnError extends boolean = false>(options: Options<AccountsGetTokenCreateData, ThrowOnError>) => (options.client ?? client).post<AccountsGetTokenCreateResponses, AccountsGetTokenCreateErrors, ThrowOnError>({
    url: '/accounts/get-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Profile
 *
 * Retrieve the authenticated user's profile information.
 */
export const profileRetrieve = <ThrowOnError extends boolean = false>(options?: Options<ProfileRetrieveData, ThrowOnError>) => (options?.client ?? client).get<ProfileRetrieveResponses, ProfileRetrieveErrors, ThrowOnError>({
    responseTransformer: profileRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/accounts/profile',
    ...options
});

/**
 * Partially Update User Profile
 *
 * Partially update the authenticated user's profile. Only first_name and last_name can be updated.
 */
export const profilePartialUpdate = <ThrowOnError extends boolean = false>(options?: Options<ProfilePartialUpdateData, ThrowOnError>) => (options?.client ?? client).patch<ProfilePartialUpdateResponses, ProfilePartialUpdateErrors, ThrowOnError>({
    responseTransformer: profilePartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/accounts/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Takes a sliding JSON web token and returns a new, refreshed version if the
 * token's refresh period has not expired.
 */
export const accountsRefreshTokenCreate = <ThrowOnError extends boolean = false>(options: Options<AccountsRefreshTokenCreateData, ThrowOnError>) => (options.client ?? client).post<AccountsRefreshTokenCreateResponses, AccountsRefreshTokenCreateErrors, ThrowOnError>({
    url: '/accounts/refresh-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Allows a user to reserve a username before the official launch. This initiates a Temporal workflow.
 */
export const accountsReserveUsernameCreate = <ThrowOnError extends boolean = false>(options: Options<AccountsReserveUsernameCreateData, ThrowOnError>) => (options.client ?? client).post<AccountsReserveUsernameCreateResponses, AccountsReserveUsernameCreateErrors, ThrowOnError>({
    url: '/accounts/reserve-username',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Takes an email address. If a user exists, it initiates a Temporal workflow to handle the password reset process.
 * Always returns 202 Accepted for security reasons.
 */
export const accountsResetPasswordCreate = <ThrowOnError extends boolean = false>(options: Options<AccountsResetPasswordCreateData, ThrowOnError>) => (options.client ?? client).post<AccountsResetPasswordCreateResponses, AccountsResetPasswordCreateErrors, ThrowOnError>({
    url: '/accounts/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signals the workflow to set a new password.
 */
export const accountsResetPasswordConfirmCreate = <ThrowOnError extends boolean = false>(options: Options<AccountsResetPasswordConfirmCreateData, ThrowOnError>) => (options.client ?? client).post<AccountsResetPasswordConfirmCreateResponses, AccountsResetPasswordConfirmCreateErrors, ThrowOnError>({
    url: '/accounts/reset-password/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * API endpoint that allows annotations to be viewed or edited.
 *
 * Attributes:
 * model (Annotation): The Django model associated with this viewset.
 * serializer_class (AnnotationSerializer): The serializer class for the Annotation model.
 */
export const annotationsList = <ThrowOnError extends boolean = false>(options?: Options<AnnotationsListData, ThrowOnError>) => (options?.client ?? client).get<AnnotationsListResponses, AnnotationsListErrors, ThrowOnError>({
    responseTransformer: annotationsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/annotations',
    ...options
});

/**
 * API endpoint that allows annotations to be viewed or edited.
 *
 * Attributes:
 * model (Annotation): The Django model associated with this viewset.
 * serializer_class (AnnotationSerializer): The serializer class for the Annotation model.
 */
export const annotationsCreate = <ThrowOnError extends boolean = false>(options: Options<AnnotationsCreateData, ThrowOnError>) => (options.client ?? client).post<AnnotationsCreateResponses, AnnotationsCreateErrors, ThrowOnError>({
    responseTransformer: annotationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/annotations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * API endpoint that allows annotations to be viewed or edited.
 *
 * Attributes:
 * model (Annotation): The Django model associated with this viewset.
 * serializer_class (AnnotationSerializer): The serializer class for the Annotation model.
 */
export const annotationsDestroy = <ThrowOnError extends boolean = false>(options: Options<AnnotationsDestroyData, ThrowOnError>) => (options.client ?? client).delete<AnnotationsDestroyResponses, AnnotationsDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/annotations/{id}',
    ...options
});

/**
 * API endpoint that allows annotations to be viewed or edited.
 *
 * Attributes:
 * model (Annotation): The Django model associated with this viewset.
 * serializer_class (AnnotationSerializer): The serializer class for the Annotation model.
 */
export const annotationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<AnnotationsRetrieveData, ThrowOnError>) => (options.client ?? client).get<AnnotationsRetrieveResponses, AnnotationsRetrieveErrors, ThrowOnError>({
    responseTransformer: annotationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/annotations/{id}',
    ...options
});

/**
 * API endpoint that allows annotations to be viewed or edited.
 *
 * Attributes:
 * model (Annotation): The Django model associated with this viewset.
 * serializer_class (AnnotationSerializer): The serializer class for the Annotation model.
 */
export const annotationsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<AnnotationsPartialUpdateData, ThrowOnError>) => (options.client ?? client).patch<AnnotationsPartialUpdateResponses, AnnotationsPartialUpdateErrors, ThrowOnError>({
    responseTransformer: annotationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/annotations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * API endpoint that allows annotations to be viewed or edited.
 *
 * Attributes:
 * model (Annotation): The Django model associated with this viewset.
 * serializer_class (AnnotationSerializer): The serializer class for the Annotation model.
 */
export const annotationsUpdate = <ThrowOnError extends boolean = false>(options: Options<AnnotationsUpdateData, ThrowOnError>) => (options.client ?? client).put<AnnotationsUpdateResponses, AnnotationsUpdateErrors, ThrowOnError>({
    responseTransformer: annotationsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/annotations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * API endpoints for user onboarding.
 *
 * Manages user registration and email verification using Temporal workflows.
 */
export const assetsCreate = <ThrowOnError extends boolean = false>(options: Options<AssetsCreateData, ThrowOnError>) => (options.client ?? client).post<AssetsCreateResponses, AssetsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Viewset for Chapter model.
 */
export const chaptersList = <ThrowOnError extends boolean = false>(options?: Options<ChaptersListData, ThrowOnError>) => (options?.client ?? client).get<ChaptersListResponses, ChaptersListErrors, ThrowOnError>({
    responseTransformer: chaptersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/chapters',
    ...options
});

/**
 * Viewset for Chapter model.
 */
export const chaptersCreate = <ThrowOnError extends boolean = false>(options: Options<ChaptersCreateData, ThrowOnError>) => (options.client ?? client).post<ChaptersCreateResponses, ChaptersCreateErrors, ThrowOnError>({
    responseTransformer: chaptersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/chapters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Viewset for Chapter model.
 */
export const chaptersDestroy = <ThrowOnError extends boolean = false>(options: Options<ChaptersDestroyData, ThrowOnError>) => (options.client ?? client).delete<ChaptersDestroyResponses, ChaptersDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/chapters/{id}',
    ...options
});

/**
 * Viewset for Chapter model.
 */
export const chaptersRetrieve = <ThrowOnError extends boolean = false>(options: Options<ChaptersRetrieveData, ThrowOnError>) => (options.client ?? client).get<ChaptersRetrieveResponses, ChaptersRetrieveErrors, ThrowOnError>({
    responseTransformer: chaptersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/chapters/{id}',
    ...options
});

/**
 * Viewset for Chapter model.
 */
export const chaptersPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<ChaptersPartialUpdateData, ThrowOnError>) => (options.client ?? client).patch<ChaptersPartialUpdateResponses, ChaptersPartialUpdateErrors, ThrowOnError>({
    responseTransformer: chaptersPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/chapters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Viewset for Chapter model.
 */
export const chaptersUpdate = <ThrowOnError extends boolean = false>(options: Options<ChaptersUpdateData, ThrowOnError>) => (options.client ?? client).put<ChaptersUpdateResponses, ChaptersUpdateErrors, ThrowOnError>({
    responseTransformer: chaptersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/chapters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A viewset that provides only a 'create' action.
 */
export const checkoutsCreate = <ThrowOnError extends boolean = false>(options: Options<CheckoutsCreateData, ThrowOnError>) => (options.client ?? client).post<CheckoutsCreateResponses, CheckoutsCreateErrors, ThrowOnError>({
    responseTransformer: checkoutsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/checkouts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signals the CheckoutWorkflow that the user has cancelled the checkout flow.
 */
export const checkoutsCancelRetrieve = <ThrowOnError extends boolean = false>(options: Options<CheckoutsCancelRetrieveData, ThrowOnError>) => (options.client ?? client).get<CheckoutsCancelRetrieveResponses, CheckoutsCancelRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/checkouts/{id}/cancel',
    ...options
});

/**
 * Returns invoice details for a specific checkout.
 */
export const checkoutsInvoiceRetrieve = <ThrowOnError extends boolean = false>(options: Options<CheckoutsInvoiceRetrieveData, ThrowOnError>) => (options.client ?? client).get<CheckoutsInvoiceRetrieveResponses, CheckoutsInvoiceRetrieveErrors, ThrowOnError>({
    responseTransformer: checkoutsInvoiceRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/checkouts/{id}/invoice',
    ...options
});

/**
 * Signals the CheckoutWorkflow that the frontend has successfully completed the checkout flow.
 */
export const checkoutsSuccessRetrieve = <ThrowOnError extends boolean = false>(options: Options<CheckoutsSuccessRetrieveData, ThrowOnError>) => (options.client ?? client).get<CheckoutsSuccessRetrieveResponses, CheckoutsSuccessRetrieveErrors, ThrowOnError>({
    responseTransformer: checkoutsSuccessRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/checkouts/{id}/success',
    ...options
});

/**
 * Returns checkout data for the thanks page.
 */
export const checkoutsThanksRetrieve = <ThrowOnError extends boolean = false>(options: Options<CheckoutsThanksRetrieveData, ThrowOnError>) => (options.client ?? client).get<CheckoutsThanksRetrieveResponses, CheckoutsThanksRetrieveErrors, ThrowOnError>({
    responseTransformer: checkoutsThanksRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/checkouts/{id}/thanks',
    ...options
});

/**
 * Get all checkouts for a specific channel
 *
 * Returns all checkouts for a specific channel with pagination.
 *
 * Supports:
 * - Pagination: ?page=1&page_size=10
 * - Filter by status: ?status=success
 * - Filter by plan: ?plan=dub
 */
export const checkoutsChannelsRetrieve = <ThrowOnError extends boolean = false>(options: Options<CheckoutsChannelsRetrieveData, ThrowOnError>) => (options.client ?? client).get<CheckoutsChannelsRetrieveResponses, CheckoutsChannelsRetrieveErrors, ThrowOnError>({
    responseTransformer: checkoutsChannelsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/checkouts/channels/{channel_id}',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const dubsList = <ThrowOnError extends boolean = false>(options?: Options<DubsListData, ThrowOnError>) => (options?.client ?? client).get<DubsListResponses, DubsListErrors, ThrowOnError>({
    responseTransformer: dubsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/dubs',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const dubsCreate = <ThrowOnError extends boolean = false>(options: Options<DubsCreateData, ThrowOnError>) => (options.client ?? client).post<DubsCreateResponses, DubsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/dubs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const dubsDestroy = <ThrowOnError extends boolean = false>(options: Options<DubsDestroyData, ThrowOnError>) => (options.client ?? client).delete<DubsDestroyResponses, DubsDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/dubs/{id}',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const dubsRetrieve = <ThrowOnError extends boolean = false>(options: Options<DubsRetrieveData, ThrowOnError>) => (options.client ?? client).get<DubsRetrieveResponses, DubsRetrieveErrors, ThrowOnError>({
    responseTransformer: dubsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/dubs/{id}',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const dubsPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<DubsPartialUpdateData, ThrowOnError>) => (options.client ?? client).patch<DubsPartialUpdateResponses, DubsPartialUpdateErrors, ThrowOnError>({
    responseTransformer: dubsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/dubs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const dubsUpdate = <ThrowOnError extends boolean = false>(options: Options<DubsUpdateData, ThrowOnError>) => (options.client ?? client).put<DubsUpdateResponses, DubsUpdateErrors, ThrowOnError>({
    responseTransformer: dubsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/dubs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Parse a link and return metadata.
 */
export const linkParseLinkRetrieve = <ThrowOnError extends boolean = false>(options: Options<LinkParseLinkRetrieveData, ThrowOnError>) => (options.client ?? client).get<LinkParseLinkRetrieveResponses, LinkParseLinkRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/link/parse-link/',
    ...options
});

/**
 * API endpoints for user onboarding.
 *
 * Manages user registration and email verification using Temporal workflows.
 */
export const onboardCreate = <ThrowOnError extends boolean = false>(options: Options<OnboardCreateData, ThrowOnError>) => (options.client ?? client).post<OnboardCreateResponses, OnboardCreateErrors, ThrowOnError>({
    url: '/onboard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Completes the onboarding process for the given ephemeral link.
 *
 * Completes the email verification step of the onboarding workflow.
 *
 * Signals the OnboardWorkflow to verify the user via an ephemeral link.
 *
 * Args:
 * request (Request): The HTTP request, containing channel_id and user_id query parameters.
 * pk (str): The ID of the `EphemeralLink` for verification.
 *
 * Returns:
 * Response: A success response indicating verification completion.
 */
export const onboardVerifyRetrieve = <ThrowOnError extends boolean = false>(options: Options<OnboardVerifyRetrieveData, ThrowOnError>) => (options.client ?? client).get<OnboardVerifyRetrieveResponses, OnboardVerifyRetrieveErrors, ThrowOnError>({ url: '/onboard/{id}/verify', ...options });

/**
 * Search Amazon products via RapidAPI using query parameters.
 */
export const productsAmazonSearchRetrieve = <ThrowOnError extends boolean = false>(options: Options<ProductsAmazonSearchRetrieveData, ThrowOnError>) => (options.client ?? client).get<ProductsAmazonSearchRetrieveResponses, ProductsAmazonSearchRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/products/amazon-search/',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseList = <ThrowOnError extends boolean = false>(options?: Options<PulseListData, ThrowOnError>) => (options?.client ?? client).get<PulseListResponses, PulseListErrors, ThrowOnError>({
    responseTransformer: pulseListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseRetrieve = <ThrowOnError extends boolean = false>(options: Options<PulseRetrieveData, ThrowOnError>) => (options.client ?? client).get<PulseRetrieveResponses, PulseRetrieveErrors, ThrowOnError>({
    responseTransformer: pulseRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/{id}',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseAnnotationAnalyticsRetrieve = <ThrowOnError extends boolean = false>(options?: Options<PulseAnnotationAnalyticsRetrieveData, ThrowOnError>) => (options?.client ?? client).get<PulseAnnotationAnalyticsRetrieveResponses, PulseAnnotationAnalyticsRetrieveErrors, ThrowOnError>({
    responseTransformer: pulseAnnotationAnalyticsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/annotation_analytics',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseAnnotationsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PulseAnnotationsRetrieveData, ThrowOnError>) => (options.client ?? client).get<PulseAnnotationsRetrieveResponses, PulseAnnotationsRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/annotations',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseChapterAnalyticsRetrieve = <ThrowOnError extends boolean = false>(options?: Options<PulseChapterAnalyticsRetrieveData, ThrowOnError>) => (options?.client ?? client).get<PulseChapterAnalyticsRetrieveResponses, PulseChapterAnalyticsRetrieveErrors, ThrowOnError>({
    responseTransformer: pulseChapterAnalyticsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/chapter_analytics',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseChaptersRetrieve = <ThrowOnError extends boolean = false>(options: Options<PulseChaptersRetrieveData, ThrowOnError>) => (options.client ?? client).get<PulseChaptersRetrieveResponses, PulseChaptersRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/chapters',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseInsightsRetrieve = <ThrowOnError extends boolean = false>(options: Options<PulseInsightsRetrieveData, ThrowOnError>) => (options.client ?? client).get<PulseInsightsRetrieveResponses, PulseInsightsRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/insights',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseSummaryRetrieve = <ThrowOnError extends boolean = false>(options: Options<PulseSummaryRetrieveData, ThrowOnError>) => (options.client ?? client).get<PulseSummaryRetrieveResponses, PulseSummaryRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/summary',
    ...options
});

/**
 * A viewset that scopes querysets to the authenticated user's channel.
 *
 * This viewset requires an authenticated user. It automatically filters
 * the queryset from BaseViewset to include only objects related to the
 * current user's channel.
 */
export const pulseVideoAnalyticsRetrieve = <ThrowOnError extends boolean = false>(options?: Options<PulseVideoAnalyticsRetrieveData, ThrowOnError>) => (options?.client ?? client).get<PulseVideoAnalyticsRetrieveResponses, PulseVideoAnalyticsRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/pulse/video_analytics',
    ...options
});

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieve = <ThrowOnError extends boolean = false>(options?: Options<SchemaRetrieveData, ThrowOnError>) => (options?.client ?? client).get<SchemaRetrieveResponses, SchemaRetrieveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/schema',
    ...options
});

/**
 * Protected API endpoint that allows videos to be viewed or edited.
 */
export const videosList = <ThrowOnError extends boolean = false>(options?: Options<VideosListData, ThrowOnError>) => (options?.client ?? client).get<VideosListResponses, VideosListErrors, ThrowOnError>({
    responseTransformer: videosListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos',
    ...options
});

/**
 * Protected API endpoint that allows videos to be viewed or edited.
 */
export const videosCreate = <ThrowOnError extends boolean = false>(options: Options<VideosCreateData, ThrowOnError>) => (options.client ?? client).post<VideosCreateResponses, VideosCreateErrors, ThrowOnError>({
    responseTransformer: videosCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Protected API endpoint that allows videos to be viewed or edited.
 */
export const videosDestroy = <ThrowOnError extends boolean = false>(options: Options<VideosDestroyData, ThrowOnError>) => (options.client ?? client).delete<VideosDestroyResponses, VideosDestroyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/{key}',
    ...options
});

/**
 * Protected API endpoint that allows videos to be viewed or edited.
 */
export const videosRetrieve = <ThrowOnError extends boolean = false>(options: Options<VideosRetrieveData, ThrowOnError>) => (options.client ?? client).get<VideosRetrieveResponses, VideosRetrieveErrors, ThrowOnError>({
    responseTransformer: videosRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/{key}',
    ...options
});

/**
 * Protected API endpoint that allows videos to be viewed or edited.
 */
export const videosPartialUpdate = <ThrowOnError extends boolean = false>(options: Options<VideosPartialUpdateData, ThrowOnError>) => (options.client ?? client).patch<VideosPartialUpdateResponses, VideosPartialUpdateErrors, ThrowOnError>({
    responseTransformer: videosPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Protected API endpoint that allows videos to be viewed or edited.
 */
export const videosUpdate = <ThrowOnError extends boolean = false>(options: Options<VideosUpdateData, ThrowOnError>) => (options.client ?? client).put<VideosUpdateResponses, VideosUpdateErrors, ThrowOnError>({
    responseTransformer: videosUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve annotations for a specific video.
 */
export const videosAnnotationsList = <ThrowOnError extends boolean = false>(options: Options<VideosAnnotationsListData, ThrowOnError>) => (options.client ?? client).get<VideosAnnotationsListResponses, VideosAnnotationsListErrors, ThrowOnError>({
    responseTransformer: videosAnnotationsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/{key}/annotations',
    ...options
});

/**
 * Retrieve chapters for a specific video.
 */
export const videosChaptersList = <ThrowOnError extends boolean = false>(options: Options<VideosChaptersListData, ThrowOnError>) => (options.client ?? client).get<VideosChaptersListResponses, VideosChaptersListErrors, ThrowOnError>({
    responseTransformer: videosChaptersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/{key}/chapters',
    ...options
});

/**
 * Download a video from a third party hosting platform.
 */
export const videosDownloadrCreate = <ThrowOnError extends boolean = false>(options: Options<VideosDownloadrCreateData, ThrowOnError>) => (options.client ?? client).post<VideosDownloadrCreateResponses, VideosDownloadrCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/downloadr',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Share a video via email.
 */
export const videosShareCreate = <ThrowOnError extends boolean = false>(options: Options<VideosShareCreateData, ThrowOnError>) => (options.client ?? client).post<VideosShareCreateResponses, VideosShareCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }, { name: 'Api-Key', type: 'apiKey' }],
    url: '/videos/share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
